module.exports = __webpack_public_path__ + "img/obstruction.59335669.svg";